<template>
  <v-form ref="userForm" v-model="valid" class="mb-4">
    <v-text-field v-model="form.first_name" label="First Name" outlined dense :rules="nameRules" required />
    <v-text-field v-model="form.last_name" label="Last Name" outlined dense :rules="nameRules" required />
    <!-- <v-text-field v-model="form.email" label="Email" outlined dense :rules="emailRules" required /> -->
    <v-row>
      <v-col cols="8" >
      <v-text-field v-model="form.contact" label="Mobile no."  placeholder="This will be yours username" outlined dense :rules="contactRules" required />
      </v-col>
      <v-col cols="4" class="d-flex align-center">
        <span >(This will be yours username)</span>
      </v-col>
    </v-row>

    
    <!-- <v-text-field 
      v-model="form.password" 
      label="Password" 
      outlined 
      dense 
      type="password"
      :rules="passwordRules"
      required
    /> -->
    <v-text-field v-model="form.password" label="Password" :type="showPassword ? 'text' : 'password'" required
      class="mb-4" prepend-icon="mdi-lock" :rules="[(v) => !!v || 'Password is required']"
      :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append-inner="togglePassword">
    </v-text-field>
  </v-form>
</template>

<script setup>
import { ref } from "vue";
import {
  nameRules,
  contactRules,
  emailRules,
  passwordRules
} from "@/utils/validationRule";

const props = defineProps(["form"]);
const valid = ref(false);
const userForm = ref(null); // Add this line

const showPassword = ref(false); // For toggling password visibility
const togglePassword = () => {
  showPassword.value = !showPassword.value;
};
defineExpose({
  valid,
  validate: () => userForm.value.validate() // Properly expose validate
});
</script>